import { IState } from '../../store';

export const getPolygon = (state: IState) => {
  return state.offerData?.newObject?.polygon;
};
